import config from '../config';


export async function createImage(data, token) {
    const response = await fetch(`${config.API_URL}/image/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload image');
    }
    return (await response.json());
}


export async function updateImage(data, token) {
    const response = await fetch(`${config.API_URL}/image/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload image');
    }
    return (await response.json());
}


export async function deleteImage(imageId, token) {
    const response = await fetch(`${config.API_URL}/image/delete`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({imageId}),
    })
    if (response.status !== 200) {
        throw Error('Failed to delete image');
    }
    return (await response.json());
}


export async function createLogo(data, token) {
    const response = await fetch(`${config.API_URL}/logo`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload image');
    }
    return (await response.json());
}


export async function updateLogo(data, token) {
    const response = await fetch(`${config.API_URL}/logo/update`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
    })
    if (response.status !== 200) {
        throw Error('Failed to upload image');
    }
    return (await response.json());
}


export async function deleteLogo(token) {
    const response = await fetch(`${config.API_URL}/logo/delete`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    })
    if (response.status !== 200) {
        throw Error('Failed to delete image');
    }
    return (await response.json());
}






